export default function companyReducer (state = null, action) {
  switch (action.type) {
    case 'SET_COMPANY':
      return action.payload;
    default:
      return state;
  }
};